import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import type { SplitViewContentDefinition } from './split-view.registry'
import { SplitViewWrapper } from './split-view-wrapper.atom'

export interface SplitViewValidContentProps {
  definition: SplitViewContentDefinition
  contentData: Record<string, unknown>
  onClose: () => void
  isCloseButtonHidden?: boolean
  className?: string
}

export const SplitViewValidContent: React.FC<SplitViewValidContentProps> = ({
  definition,
  contentData,
  onClose,
  isCloseButtonHidden = false,
  className,
}): ReactNode => {
  const IconComponent = definition.icon
  const iconClassName = definition.iconClassName ?? 'text-primary'
  const iconElement = <IconComponent className={cn('size-4', iconClassName)} />

  const ContentComponent = definition.component
  const subtitle = definition.subtitle?.(contentData)
  const onTitleClick = definition.onTitleClick?.(contentData)

  return (
    <SplitViewWrapper
      title={definition.title}
      subtitle={subtitle}
      icon={iconElement}
      onClose={onClose}
      onTitleClick={onTitleClick}
      isCloseButtonHidden={isCloseButtonHidden}
      className={className}
    >
      <ContentComponent data={contentData} />
    </SplitViewWrapper>
  )
}
